import http from './http'
export default <{ [key: string]: any }>{
    getFuncLevel(funcName: string = "") {
        return http.get("Agency/getFuncLevel/" + funcName);
    },

    Signup(data: any = {}) {
        return http.post("SignAccount/company", data);
    },
    Login(Logindata: any) {
        return http.post("Login/company", Logindata);
    },
    CheckCompany(taxId: string) {
        return http.post("check/company", { taxId: taxId });
    },
    Logout() {
        return http.get("Logout");
    },
    async checkUser() {
        return await http.get("checkUser");
    },
    getBaseUser() {
        return http.get("Agency/check");
    },
    async getVerification(method: string) {
        return http.get(`Agency/getVerification/${method}`)
    },
    async sendVerification(method: string, code: string) {
        return await http.get(`Agency/sendVerification/${method}/${code}`)
    },
    async getCompanyPerson(acUid: string) {
        return await http.get(`Agency/getCompanyPerson`, { acUid: acUid })
    },
    async getCompanyInfo() {
        return await http.get(`Agency/getCompanyInfo`)
    },
    async getCompanyAccount() {
        return await http.get(`Agency/getCompanyAccount`)
    },
    async SaveAccountInfo(type: string, formdata: any) {
        return await http.post(`Agency/SaveAccountInfo/${type}`, formdata);
    },
    async SaveCompanyInfo(formdata: any) {
        return await http.post(`Agency/SaveCompanyInfo`, formdata)
    },
    async ChangePasswordInfo(method: string, formdata: any) {
        return await http.post(`Agency/ChangePasswordInfo/${method}`, formdata);
    },
    async changeAccess(uid: string, formdata: any) {
        return await http.post(`Agency/changeAccess/${uid}`, { formdata: formdata });
    },
    async deleteUser(uid: string) {
        return await http.post(`Agency/deleteUser/${uid}`);
    },
    async getBankAccount(where = {}) {
        return await http.get("Agency/getBankAccount", where, null, "getBankAccount");
    },
    async getBankAccountInfo(bankUid: string) {
        return await http.get(`Agency/getBankAccountInfo/${bankUid}`, {}, null, "getBankAccountInfo");
    },
    editCompanyStamp(formdata: any, uid: string = "add") {
        return http.post(`Agency/editCompanyStamp/${uid}`, formdata);
    },
    getCompanyStampList() {
        return http.get(`Agency/getCompanyStampList`);
    },
    async EditTapPay(formdata: any) {
        return await http.post("Pay/EditTapPay", formdata);
    },
    async Edit91App(formdata: any) {
        return await http.post("Pay/Edit91App", formdata);
    },
    check91App(txntoken: string, payMethod: string | null = null) {

        return http.get(`91App/check91App/${payMethod || 'account'}`, {
            token: txntoken
        });
    },
    async settingService() {
        return await http.get("Pay/SettingService");
    },
    async EditsettingService(formdata: any) {
        return await http.post(`Pay/SettingService/${formdata.method}`, formdata);
    },
    checkFundPay(payMethod: string | null = null) {
        return http.get(`FundPay/checkFundPay/${payMethod || 'account'}`);
    },
    EditFundPay(formdata: any) {
        return http.post("FundPay/EditFundPay", formdata);
    },
    // 帳戶處理
    getBankList(request = {}) {
        return http.get(`datainfo/getBankList`, request, null, "getBankList");
    },
    addBank(formdata: any) {
        return http.post(`Pay/EditBank/add`, formdata);
    },
    EditBank(method: string, uid: string, formdata: any) {
        return http.post(`Pay/EditBank/${method}/${uid}`, formdata);
    },
    checkInCollection(method: string, PayMethod: string, uid: string) {
        return http.post(`Pay/checkInCollection/${method}/${PayMethod}/${uid}`);
    },
    getVendor(search: any = {}, page: number = 0, pagenumber: number = 20) {
        return http.get(`Agency/getVendor/${page}/${pagenumber}`, {
            search: search
        })
    },

    getVendorInfo(uid: string) {
        return http.get(`Agency/getVendorInfo/${uid}`)
    },
    EditVendorInfo(uid: string, formdata: any) {
        return http.post(`Agency/EditVendorInfo/${uid}`, formdata)
    },

    // 平台這行要刪除
    getAgencyList() {
        return http.get(`Agency/List`);
    },
    getTraveler(search: any = {}, page: number = 0, pagenumber: number = 20, orderBy: { name: string, order: string }, addfunc: Array<any> = []) {
        return http.get(`Agency/getTraveler/${page}/${pagenumber}`, {
            search: search,
            orderBy: orderBy,
            addfunc: addfunc
        })
    },
    getMember(search: any = {}, page: number = 0, pagenumber: number = 20, orderBy: { name: string, order: string }, addfunc: Array<any> = []) {
        return http.get(`Agency/getMember/${page}/${pagenumber}`, {
            search: search,
            orderBy: orderBy,
            addfunc: addfunc
        })
    },
    getMemberInfo(uid: string) {
        return http.get(`Agency/getMemberInfo/${uid}`)
    },
    EditMemberInfo(uid: string, formdata: any) {
        return http.post(`Agency/EditMemberInfo/${uid}`, formdata)
    },
    getMemberDashboard(uid: string) {
        return http.get(`Agency/getMemberDashboard/${uid}`);
    },
    getMemberEditLog(uid: string, page: number, pagenumber: number | "all" = 20) {
        return http.get(`Agency/getMemberEditLog/${uid}/${page}/${pagenumber}`);
    },
    getLevelGroupList(page: number, pagenumber: string | number, search: any) {
        return http.get(`Agency/getLevelGroupList/${page}/${pagenumber}`, { search: search });
    },
    getLevelGroupInfo(uid: string) {
        return http.get(`Agency/getLevelGroupInfo/${uid}`);
    },
    EditLevelGroup(uid: string = "", formdata: any) {
        return http.post(`Agency/EditLevelGroup/${uid}`, { formdata: formdata });
    },
    getDashBoard() { 
        return http.get("Agency/getDashBoard");
    }

}